import styled from '../../../../styles/theme';
import { PriceBoxStyled } from '../PriceBoxStyled';
import { rem } from 'polished';

export const PriceBoxStyledAC = styled(PriceBoxStyled)`
    background-color: rgba(161, 154, 153, 0.1);

    .catalogPrice {
        color: ${({ theme }) => theme.colors.grey11};
        line-height: ${({ theme }) => theme.lineHeights.textSupMedium};

        .catalogPriceLabel {
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};
        }
        .catalogPriceAmount {
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};
            font-weight: ${({ theme }) => theme.fontWeights.textExtraBold};
        }

        .currencyLabel__suffix--OTR  {
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
        }
    }

    .priceBoxWrapper {
        .financeLabel  {
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};
            color: ${({ theme }) => theme.colors.grey11};

            .specialPriceLabel {
                font-weight: ${({ theme }) => theme.fontWeights.textBold};
            }

            .priceLabel {
                font-weight: ${({ theme }) => theme.fontWeights.textExtraBold};
            }
        }

        .price {
            .cashPrice,
            .monthlyPrice {
                font-weight: ${({ theme }) => theme.fontWeights.textExtraBold};
                font-size: ${({ theme }) => theme.fontSizes.h2};
            }

            .priceConjunction {
                font-size: ${({ theme }) => theme.fontSizes.textSupBase};
            }

            .monthlyPrice {
                font-size: ${rem('21px')};
                .infoIcon {
                    height: ${rem(22)};
                    
                    svg {
                        line,
                        circle {
                            stroke: ${({ theme }) => theme.colors.grey1};
                        }
                    }
                }
            }

            .currency,
            .currencyLabel__suffix--OTR,
            .currencyLabel__suffix--TTC {
                font-size: ${({ theme }) => theme.fontSizes.h5};
                font-weight: ${({ theme }) => theme.fontWeights.textExtraBold};
            }

            .currencyLabel__suffix--TTC-monthly {
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                text-transform: lowercase;
            }
        }

        .priceNotice {
            font-size: ${({ theme }) => theme.fontSizes.textBase};

            .promotionalText {
                color: ${({ theme }) => theme.colors.grey1};
            }
        }
    }
`;
